import { LoadingOutlined } from "@ant-design/icons";

const Index = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 mt-10">
      <LoadingOutlined className="text-2xl" />
      <span>Түр хүлээнэ үү</span>
    </div>
  );
};

export default Index;
